import {createAsyncThunk} from '@reduxjs/toolkit'

import {NAVERPAY_BENEFIT_DOMESTIC, NAVERPAY_BENEFIT_FOREIGN} from '@web/core/urls'
import {changeBrowserLocation, openNewTab} from '@web/helpers/browser'
import {isMobile} from '@web/helpers/userAgent'

import {NavigationResult, NavigationTypeSelectableParam, ThunkApi} from '../interfaces'

interface NavigateToNaverPayEventParams extends NavigationTypeSelectableParam {
    /** 해외결제 여부 */
    isInternationalPayment: boolean
}

const navigateToNaverPayEvent = createAsyncThunk<NavigationResult, NavigateToNaverPayEventParams, ThunkApi>(
    'navigateTo/naverPayEvent',
    async ({isInternationalPayment}) => {
        const url = isInternationalPayment ? NAVERPAY_BENEFIT_FOREIGN : NAVERPAY_BENEFIT_DOMESTIC

        if (isMobile) {
            changeBrowserLocation({
                url,
                type: 'PUSH',
            })

            return Promise.resolve()
        }

        openNewTab({url})
    },
)

export default navigateToNaverPayEvent
